import { GravyBinder } from "gravy-bind";
import { MDCLinearProgress } from '@material/linear-progress';
import { MDCSelect } from '@material/select';
import { PublicationsService } from "../services/publications.service";
import { loopThroughElements } from "../utils/loop-through-elements";
import { PublicationPreference } from "../models/publication-preference";

export class PublicationsManager {
    public static cssClass = "publications-manager";
    private binder: GravyBinder;
    private rootElement: HTMLFormElement;
    public isSaving: boolean;
    public isSaveComplete: boolean = false;
    private loader: MDCLinearProgress;
    public preferences: { [preferenceId: string]: string } = {};
    private service: PublicationsService = new PublicationsService();

    constructor(rootElement: HTMLElement) {
        this.rootElement = rootElement as HTMLFormElement;
        this.initialize()
    };

    private initialize = async (): Promise<void> => {
        this.bindEvents();
        this.binder = new GravyBinder(this, this.rootElement);
        this.loader = new MDCLinearProgress(this.rootElement.querySelector('.mdc-linear-progress'));
        this.loader.determinate = false;
        this.loader.open();
        this.binder.updateOutwardBindings();

        const prefs = await this.service.getPreferences();
        this.applyPreferences(prefs);

        this.binder.updateBindings();
        this.loader.close();
    };

    private applyPreferences = (preferences: Array<PublicationPreference>): void => {
        preferences.forEach(preference => {
            this.preferences[preference.publicationName] = preference.setting;

            const element = this.rootElement.querySelector(`md-outlined-select[data-for="${preference.publicationName}"]`);
            if (element) {
                const options = element.querySelectorAll('md-select-option');
                options.forEach(opt => opt.removeAttribute('selected'));

                const targetOption = element.querySelector(`md-select-option[value="${preference.setting}"]`);
                if (targetOption) {
                    targetOption.setAttribute('selected', '');
                    console.log(`Selected option ${preference.setting} for ${preference.publicationName}`);
                }

                element.addEventListener('change', (evt: any) => {
                    this.preferences[preference.publicationName] = evt.target.value;
                    this.isSaveComplete = false;
                });
            }
        });
    };

    private bindEvents = (): void => {
        this.rootElement.addEventListener('submit', event => event.preventDefault());
        loopThroughElements(this.rootElement.getElementsByClassName('publications-manager__save'), button => {
            button.addEventListener('click', this.saveChanges);
        });
    };

    public saveChanges = async (): Promise<void> => {
        this.loader.open();
        this.binder.updateInputBindings();

        const prefs = Object.keys(this.preferences)
            .map(key => PublicationPreference.fromJson({
                publicationName: key,
                setting: this.preferences[key]
            }));
        await this.service.setPreferences(prefs);

        this.loader.close();
        this.isSaveComplete = true;
        this.binder.updateOutwardBindings();
    };
}